'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.monitor.edit', [])
  .controller('MonitorEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/monitor/edit/index.js